import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// import axios from 'axios'
import moment from 'moment';
import sanitizeHtml from 'sanitize-html';
import _ from 'lodash'; // ------------------------------

var state = {
  website_host: 'localhost',
  colors: ['primary', // 'link',
  'info', 'success', 'warning', 'danger', 'secondary'],
  grays: ['black', 'dark', 'light', 'white'],
  sizes: ['small', 'normal', 'medium', 'large'],
  drawer: {
    show: false
  },
  pages: [{
    id: 'index',
    name: 'HOME'
  }, {
    id: 'news',
    name: 'お知らせ'
  }, {
    id: 'profile',
    name: 'プロフィール'
  }, {
    id: 'research',
    name: '研究実績'
  }, {
    id: 'educations-seminars',
    name: '教育・ゼミ・講演会活動'
  }, {
    id: 'contact',
    name: 'お問い合わせ'
  }, {
    id: 'request',
    name: '講演・講師依頼'
  }]
}; // ------------------------------

var getters = {
  h: function h() {
    return function (str) {
      try {
        // v-htmlの脆弱性対策
        return sanitizeHtml(str);
      } catch (error) {
        return '';
      }
    };
  },
  blankAppName: function blankAppName() {
    return "\u7814\u7A76\u5BA4\u540D\u79F0";
  },
  allColors: function allColors(state) {
    return [].concat(_toConsumableArray(state.grays), _toConsumableArray(state.colors));
  },
  setDate: function setDate() {
    return function (date) {
      try {
        if (!date) return null;

        if (moment(date).isValid()) {
          return moment(date).format('YYYY/MM/DD');
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    };
  },
  setTableClass: function setTableClass() {
    return function () {
      try {
        var tables = document.querySelectorAll('.content table');

        if (tables.length) {
          _.map(tables, function (i) {
            i.outerHTML = "<div class=\"scrolling-table\">".concat(i.outerHTML, "</div>");
          });
        }

        return null;
      } catch (error) {
        return null;
      }
    };
  },
  isLocal: function isLocal() {
    return function () {
      try {
        switch (true) {
          case _.includes(location.hostname, '192.168'):
          case _.includes(location.hostname, 'localhost'):
            return true;

          default:
            return false;
        }
      } catch (error) {
        return false;
      }
    };
  },
  getHost: function getHost(state) {
    switch (true) {
      case state.website_host == '':
      case state.website_host == '<mt:WebsiteHost>':
      case _.isNull(state.website_host):
      case _.isUndefined(state.website_host):
        return '';

      default:
        return "//".concat(state.website_host);
    }
  }
}; // ------------------------------

var mutations = {
  WEBSITE_HOST: function WEBSITE_HOST(state, data) {
    state.website_host = data;
  },
  DRAWER: function DRAWER(state) {
    state.drawer.show = !state.drawer.show;
  }
}; // ------------------------------

var actions = {};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};